module cr.entity
{
    entityModule.directive('crPlugin', ['$compile', function ($compile) {
        return {
            restrict: 'AE',
            scope: {
                'name': '=',
                'id': '='
            },
            transclude: false,
            link: function (scope, element,attributes,xx,transclude) {

                var newScope: any = null;
                var newElement: any = null;

                var i=0;

                element.on("$destroy",function(){
                    console.log("destroy element");
                });

                function updateContent() {

                    if (newScope!=null)
                    {
                        newScope.$destroy();
                        newScope=null;
                    }
                    if (newElement!=null)
                    {
                        newElement.remove();
                        newElement=null;
                    }

                    if (scope.name != null && scope.name != '') {
                        newScope=scope.$new();

                        var template = "<" + scope.name +" />";
                        newElement = $compile(template)(newScope);

                        element.html(newElement);
                    } else {
                        element.html("EMPTY");
                    }
                }

                scope.$watch('name+id', function (value) {
                    console.log("plugin watch called: "+scope.name+"/"+scope.id);
                    updateContent();
                });

                updateContent();

            }
        };
    }]);

}
